import BaseFeature from '../../foundation/base/base';
import Breakpoints from '../../foundation/utilities/breakpoints';

export class factboxPublication extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;
		this.contentBlock = document.querySelector('.o-content-block__content');
		this.screenWidth = window.innerWidth;

		this.moveSpot();

		this.log('factboxPublication');
	}

	moveSpot() {
		if (this.screenWidth < Breakpoints.md()) {
			this.contentBlock.prepend(this.el);
		}
	}
}

export default factboxPublication;
